import { ScrollArea } from '@base-ui/react/scroll-area';

export function Scrollable({
  children,
  className
}: React.PropsWithChildren<{ className?: string }>) {
  return (
    <ScrollArea.Root className={className}>
      <ScrollArea.Viewport className="h-full mask-linear-[to_bottom,transparent_0,black_min(40px,var(--scroll-area-overflow-y-start)),black_calc(100%-min(40px,var(--scroll-area-overflow-y-end,40px))),transparent_100%] mask-no-repeat outline-none">
        <ScrollArea.Content>{children}</ScrollArea.Content>
      </ScrollArea.Viewport>
      <ScrollArea.Scrollbar className="pointer-events-none m-px flex w-1.5 justify-center rounded-sm opacity-0 transition-opacity duration-150 ease-out data-hovering:pointer-events-auto data-hovering:opacity-100 data-scrolling:pointer-events-auto data-scrolling:opacity-100 data-scrolling:duration-0 motion-reduce:transition-none">
        <ScrollArea.Thumb className="w-full rounded-sm bg-black/40 dark:bg-white/40" />
      </ScrollArea.Scrollbar>
    </ScrollArea.Root>
  );
}
